import React from 'react'
export default function Progress({ step }) {

    return (
        <div id="progressbarContainer">
            <div id="emptyProgressbar"></div>
            <div id="completedProgress" style={{ 'width': step === 4 ? '100%' : 100 - 100 / (step - 1) + '%' }}></div>
            <ul className="p-0 mb-0">
                <li className={step > 2 ? 'completedStep' : (step <= 2 ? 'activeStep' : '')} id="stepLable2">{step > 2 ? <i className="fa fa-check"></i> : 1}</li>
                <li className={step > 3 ? 'completedStep' : (step === 3 ? 'activeStep' : '')} id="stepLable3">{step > 3 ? <i className="fa fa-check"></i> : 2}</li>
                <li className={step === 4 ? 'activeStep' : ''} id="stepLable4">{step > 4 ? <i className="fa fa-check"></i> : 3}</li>
            </ul>
        </div>
    )



}
